// removed by extract-text-webpack-plugin
module.exports = {"buttonArea":"_26FWkUKSo6-VtmSGhCRPC4"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Tools/style.scss
// module id = 1257
// module chunks = 0